module.exports = __webpack_public_path__ + "img/jquery.1cacde53.png";